import { useEffect, useState } from "react";
import { DownloadSimple, X as XIcon } from "@phosphor-icons/react";

const DISMISS_KEY = "pwa-install-dismissed-at";
const DISMISS_COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

export default function PWAInstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // If user recently dismissed, don't show at all
    const dismissedAt = Number(localStorage.getItem(DISMISS_KEY) || 0);
    if (dismissedAt && Date.now() - dismissedAt < DISMISS_COOLDOWN_MS) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      // Delay 5s so we don't interrupt the initial page load
      const t = setTimeout(() => setVisible(true), 5000);
      return () => clearTimeout(t);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try {
      await deferred.userChoice;
    } catch {
      /* user closed the prompt — nothing to do */
    }
    setDeferred(null);
    setVisible(false);
  };

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setVisible(false);
  };

  if (!visible || !deferred) return null;

  return (
    <div className="pwa-prompt" dir="rtl" data-testid="pwa-install-prompt">
      <div className="pwa-prompt-content">
        <button
          onClick={dismiss}
          aria-label="إغلاق"
          data-testid="pwa-dismiss"
          className="w-8 h-8 rounded-full text-white/50 hover:text-white hover:bg-white/10 inline-flex items-center justify-center shrink-0"
        >
          <XIcon size={14} weight="bold" />
        </button>
        <button
          onClick={install}
          data-testid="pwa-install"
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-primary text-primary-foreground hover:bg-[#E1C484] font-bold text-sm shrink-0"
        >
          <DownloadSimple size={14} weight="bold" /> تثبيت
        </button>
        <div className="flex-1 text-right">
          <div className="text-primary font-bold text-sm">ثبّت مراسم الزوار كتطبيق</div>
          <div className="text-white/60 text-xs mt-0.5">
            وصول أسرع من شاشتك الرئيسية بضغطة واحدة — دون شريط عنوان.
          </div>
        </div>
        <div className="text-2xl shrink-0">📱</div>
      </div>
    </div>
  );
}
